export const shouldLoadMoreWorkspaceAgentTableRows = ({
  atLastLoadedPage,
  canLoadMore,
  hasMore,
  isLoadingMore,
}: {
  atLastLoadedPage: boolean;
  canLoadMore: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
}): boolean => hasMore && atLastLoadedPage && canLoadMore && !isLoadingMore;
